/**
 * A SMALL SAMPLE of the NAICS 2022 reference for the mock gateway only: the 20 sectors and 40 detailed industries, copied from the official code list. The real
 * service searches all 1,012 detailed industries (GET /api/reference/naics/industries). Generated from the checked-in package; do not edit by hand.
 */
export const MOCK_NAICS_VERSION = '2022';

export const MOCK_NAICS_SECTORS: ReadonlyArray<readonly [string, string]> = [
  ["11", "Agriculture, Forestry, Fishing and Hunting"],
  ["21", "Mining, Quarrying, and Oil and Gas Extraction"],
  ["22", "Utilities"],
  ["23", "Construction"],
  ["31-33", "Manufacturing"],
  ["42", "Wholesale Trade"],
  ["44-45", "Retail Trade"],
  ["48-49", "Transportation and Warehousing"],
  ["51", "Information"],
  ["52", "Finance and Insurance"],
  ["53", "Real Estate and Rental and Leasing"],
  ["54", "Professional, Scientific, and Technical Services"],
  ["55", "Management of Companies and Enterprises"],
  ["56", "Administrative and Support and Waste Management and Remediation Services"],
  ["61", "Educational Services"],
  ["62", "Health Care and Social Assistance"],
  ["71", "Arts, Entertainment, and Recreation"],
  ["72", "Accommodation and Food Services"],
  ["81", "Other Services (except Public Administration)"],
  ["92", "Public Administration"],
];

/** [code, title, sector code] */
export const MOCK_NAICS_INDUSTRIES: ReadonlyArray<readonly [string, string, string]> = [
  ["111110", "Soybean Farming", "11"],
  ["111419", "Other Food Crops Grown Under Cover", "11"],
  ["211120", "Crude Petroleum Extraction", "21"],
  ["221114", "Solar Electric Power Generation", "22"],
  ["236220", "Commercial and Institutional Building Construction", "23"],
  ["238210", "Electrical Contractors and Other Wiring Installation Contractors", "23"],
  ["238220", "Plumbing, Heating, and Air-Conditioning Contractors", "23"],
  ["311811", "Retail Bakeries", "31-33"],
  ["321999", "All Other Miscellaneous Wood Product Manufacturing", "31-33"],
  ["332710", "Machine Shops", "31-33"],
  ["423120", "Motor Vehicle Supplies and New Parts Merchant Wholesalers", "42"],
  ["424410", "General Line Grocery Merchant Wholesalers", "42"],
  ["441110", "New Car Dealers", "44-45"],
  ["445110", "Supermarkets and Other Grocery Retailers (except Convenience Retailers)", "44-45"],
  ["484110", "General Freight Trucking, Local", "48-49"],
  ["493110", "General Warehousing and Storage", "48-49"],
  ["518210", "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services", "51"],
  ["522110", "Commercial Banking", "52"],
  ["524210", "Insurance Agencies and Brokerages", "52"],
  ["531210", "Offices of Real Estate Agents and Brokers", "53"],
  ["541211", "Offices of Certified Public Accountants", "54"],
  ["541511", "Custom Computer Programming Services", "54"],
  ["541330", "Engineering Services", "54"],
  ["561320", "Temporary Help Services", "56"],
  ["561720", "Janitorial Services", "56"],
  ["611110", "Elementary and Secondary Schools", "61"],
  ["611691", "Exam Preparation and Tutoring", "61"],
  ["621111", "Offices of Physicians (except Mental Health Specialists)", "62"],
  ["621610", "Home Health Care Services", "62"],
  ["622110", "General Medical and Surgical Hospitals", "62"],
  ["623110", "Nursing Care Facilities (Skilled Nursing Facilities)", "62"],
  ["624110", "Child and Youth Services", "62"],
  ["711510", "Independent Artists, Writers, and Performers", "71"],
  ["713940", "Fitness and Recreational Sports Centers", "71"],
  ["722511", "Full-Service Restaurants", "72"],
  ["721110", "Hotels (except Casino Hotels) and Motels", "72"],
  ["811111", "General Automotive Repair", "81"],
  ["812112", "Beauty Salons", "81"],
  ["921110", "Executive Offices", "92"],
  ["922160", "Fire Protection", "92"],
];
